import { ToastProvider } from '@idexx-laboratories/spot-react';
import React, { ReactElement } from 'react';
import { Outlet } from 'react-router';
import Auth0ProviderWithNavigate from './providers/Auth0ProviderWithNavigate';
import RootStore from './store/RootStore';
import { StoreProvider } from './store/StoreContext';

const rootStore = new RootStore();

/**
 * Root provider component that wraps all routes with necessary providers.
 * This component is rendered as the root element in the router configuration.
 */
const RootProvider = (): ReactElement => (
  <ToastProvider>
    <Auth0ProviderWithNavigate>
      <StoreProvider store={rootStore}>
        <Outlet />
      </StoreProvider>
    </Auth0ProviderWithNavigate>
  </ToastProvider>
);

export default RootProvider;
